import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import TimeEntry from "@/pages/TimeEntry";
import Clients from "@/pages/Clients";
import Reports from "@/pages/Reports";

function App() {
  return (
    <div className="App min-h-screen bg-[#09090B]">
      <div className="noise-overlay" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="time-entry" element={<TimeEntry />} />
            <Route path="time-entry/:id" element={<TimeEntry />} />
            <Route path="clients" element={<Clients />} />
            <Route path="reports" element={<Reports />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-center" 
        theme="dark"
        toastOptions={{
          style: {
            background: '#18181B',
            border: '1px solid #27272A',
            color: '#FAFAFA',
          },
        }}
      />
    </div>
  );
}

export default App;
